/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CommonDateTime } from "../../Api/commonDateTime";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import ReusableTable from "../UserInformation/ReusableTable";
const Transaction = () => {
  const { search, transactionList, userId, formDate, toDate,userList } = useSelector((state) => state.adminReducers);
  const [currentPage, setCurrentPage] = useState(search ? 1 : 1); // Initialize currentPage based on search
  const { websocket } = useContext(WebSocketContext);
  const [activeTableDetails, setActiveTableDetails] = useState(null); // Initialize as null
  const [optionsRegion, SetOptionsRegion] = useState(() => userList?.list?.filter((elm) => elm?.is_active)?.map((item, index) => ({ key: item.id, value: item?.id, label: item?.username })));

  useEffect(() => {  
    let param = {
        "transmit": "single",
        "url": "user_list",
        "request": {
          "status": true,
          "limit": "10000000",
          "page_no": 1,
          "search": "",
          "order_by": "-updated_at",
            "user_type":"user"
        }
      }
      wsSend_request(websocket, param)}, [websocket]);
  useEffect(() => {
    const param = {
      "transmit": "single",
      "url": "transaction_list",
      "request": {
        "limit": "20",
        "page_no": search ? 1 : currentPage,
        "search": search || "",
        "order_by": "-updated_at",
        "user_id": userId || "" 
      }
    };

    if (formDate && toDate) {
      param.request.from_date = CommonDateTime(formDate, "YYYY-MM-DD", "hide")+" "+CommonDateTime(formDate, "HH:mm", "show");
      const formattedToDate = CommonDateTime(toDate, "YYYY-MM-DD", "hide") + " " +
      (CommonDateTime(toDate, "HH:mm", "show") === "00:00" ? "23:59" : CommonDateTime(toDate, "HH:mm", "show"));
      param.request.to_date = formattedToDate;

    }

    wsSend_request(websocket, param);
  }, [websocket, currentPage, search, userId, formDate, toDate]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

function tcnStatus(status){
   if (status==="credit_wallet"){
    return{
      name:"Purchase",
      color:"#000000"
    }
   }
   if (status==="debit_wallet"){
    return{
      name:"Purchase",
      color:"#000000"
    }
   }
   if (status==="Refund (Manually)"){
    return{
      name:"Refund",
      color:"#5666B9"
    }
   }
   if (status==="transfer_credit_wallet" || status==="transfer_debit_wallet" || status ==="Transfer"){
    return{
      name:"Transfer",
      color:"#00AE5B"
    }
   }
   if (status==="Refund (Un-utlized)"){
    return{
      name:"Unutilised",
      color:"#000000"
    }
   }
   if(status==="debit_order"){
    return{
      name:"Order",
      color:"#F5A200"
    }
   }
}

const UserDetail = (id) => {
  const userInf = userList?.list?.filter((user) => user?.id === id)[0]
  return {
    userName: userInf?.username,
    useEmail: userInf?.email,
    mobileNUmber: userInf?.phone,
    user_code:userInf?.user_code
  }
}



  // Toggle function for table details
  const toggleDetails = (id) => {
    setActiveTableDetails(prevId => (prevId === id ? null : id));
  };  

const headers = [
  { name: "Date & Time", key: "dateTime" },
  { name: "User ID", key: "userId" },
  { name: "Transaction Type", key: "transactionType" },
  { name: "Arvgo Transaction Id", key: "arvgoTransactionId" },
  { name: "Amount", key: "amount" },
  { name: "Status", key: "status" },
];

  const renderRow = (transaction, index,visibleColumns) => {    
            return(
          <React.Fragment key={transaction?.id}>
          <tr className="user-management-table-detail">

                   {visibleColumns?.includes("dateTime")&&<td style={{ cursor: "default" }} className="Vertical_align" >
                    {moment(transaction.created_at).format("YYYY-MM-DD HH:mm:ss")}
                   </td>} 
                   {visibleColumns?.includes('userId')&&<td className="Vertical_align">{transaction?.user_code || "-"}</td>} 
                   {visibleColumns?.includes('transactionType')&&<td className="Vertical_align"><span style={{color:tcnStatus(transaction.trn_type)?.color}} >{tcnStatus(transaction.trn_type)?.name}</span></td>}
                   {visibleColumns?.includes('arvgoTransactionId')&&<td className="Vertical_align">{transaction.transaction_id}</td>} 
                   {visibleColumns?.includes('amount')&&<td className="Vertical_align">{`Rm ${parseFloat(transaction.total_amount).toFixed(2) || "-"}`}</td>} 
                   {visibleColumns?.includes('status')&&<td className="Vertical_align">
                           <div style={{ color: "black",background:transaction.status.toUpperCase() === "PAID" ? "#B6EFBB":"#F7ABAB",borderRadius:"4px",padding:"5px",textAlign:"center" }}>
                             {(transaction.status)?.toUpperCase() === "PAID" ? "SUCCESS" : "UNSUCCESS"}</div>
                   </td>}
                  </tr>
                  {activeTableDetails === transaction.id && (
                    <tr className="tablecollapsewraps" id={"tablecollapse" + transaction.id}>
                      <td colSpan="6">
                        <table className="table border">
                          <tbody>
                            <tr className="user-management-table-detail">
                              <th style={{ width: "20%", color: "black" }}>Notes</th>
                              <td>{transaction.notes || "-"}</td>
                            </tr>
                            <tr className="user-management-table-detail">
                              <th style={{ width: "20%", color: "black" }}>Previous Balance</th>
                              <td>{`Rm ${transaction.previous_balance || "-"}`}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
          </React.Fragment>
        );
    
  }

  return (
    <>
      <ReusableTable
        headers={headers}
        data={transactionList?.list || []}
        paginationObject={transactionList?.pagination}
        renderRow={renderRow}
        filters={{
          fromDate: true,
          toDate: true,
          period: true,
          search: true,
          searchPlaceholder: "Search by Transaction Type, Arvgo Transaction Id, User ID",
          userSelect: true,
          userOptions:optionsRegion,
          export: true,
          reset:true,
         }}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
       />
    </>
  );
};

export default Transaction;
